module.exports = __webpack_public_path__ + "static/img/bjd3.26e9c7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjd3.png
// module id = UXau
// module chunks = 0